import { App } from "vue";

import vTooltip from "./vTooltip";
import vHotkey from "./vHotkey";
import panel from "./panel";
import focus from "./focus";

declare module "vue" {
    interface ComponentCustomProperties {
        vTooltip: typeof vTooltip;
        vHotkey: typeof vHotkey;
        vPanel: typeof panel;
        vFocus: typeof focus;
    }
}

export default {
    install: (app: App) => {
        app.directive("tooltip", vTooltip);
        app.directive("hotkey", vHotkey);
        app.directive("panel", panel);
        app.directive("focus", focus);
    },
};
